import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateRolePage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: '',
    permissions: [],
    inheritFrom: '',
  });

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      toast.error('Введите название роли');
      return;
    }
    // TODO: Добавить API запрос
    toast.info('Функционал в разработке');
  };

  return (
    <FormLayout
      onSubmit={handleSubmit}
      onBack={() => navigate('/roles')}
      saving={saving}
      submitText="Создать"
      savingText="Создание..."
    >
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Название роли" required>
              <Form.Control
                type="text"
                value={form.name}
                onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
                placeholder="Администратор"
              />
            </FormField>
          </Col>
          <Col md={6}>
            <FormField label="Наследовать от">
              <Form.Select
                value={form.inheritFrom}
                onChange={(e) => setForm((prev) => ({ ...prev, inheritFrom: e.target.value }))}
              >
                <option value="">Не выбрано</option>
                <option value="1">Пользователь</option>
                <option value="2">Администратор</option>
                <option value="3">Модератор</option>
              </Form.Select>
            </FormField>
          </Col>
        </Row>

        <FormField label="Права">
          <Form.Select multiple style={{ height: '150px' }}>
            <option>Создание пользователей</option>
            <option>Редактирование контента</option>
            <option>Управление заказами</option>
          </Form.Select>
        </FormField>
      </FormSection>
    </FormLayout>
  );
};

export default CreateRolePage;
